// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"261":"9b188d56","488":"cbe284e0"}[chunkId] + ".chunk.js";
};